/**
 * True when a posting field holds one link and nothing else: the visitor
 * pasted the ad's URL rather than its text (usePostingFromUrl). Only full
 * links and `www.` ones count, so a link typed by hand is not fetched halfway.
 */
export function isPostingUrl(text: string): boolean {
  const value = text.trim()
  return value.length <= 2048 && /^(?:https?:\/\/|www\.)[^\s/]+\.[^\s/]+\S*$/i.test(value)
}
